<style lang="scss">
.v-application {
  min-height: 0;

  .v-application--wrap {
    min-height: 0;
  }
}
</style>

<template>
  <v-app>
    <router-view :key="$route.path"></router-view>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
